import * as React from "react";
import { AnchoredPanelProps } from "./AnchoredPanelTypes";
import { InternalAnchoredPanel } from "./InternalAnchoredPanel";

export const AnchoredPanel = ({ ...props } : AnchoredPanelProps): JSX.Element => (
  <InternalAnchoredPanel
    {...props}
  />
);
